'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    tableRowContainer: {},
    tableRow: {
      transition: theme.transition(['all']),
      '&.active, &.active:hover': {
        color: theme.table.cellActiveColor,
        backgroundColor: theme.table.rowActiveBgColor
      },
      '&:hover': {
        backgroundColor: theme.table.rowHoverBgColor
      }
    },
    tableList: {
      display: 'flex',
      alignItems: 'center',
      minHeight: 56,
      paddingTop: 4,
      paddingBottom: 4,
      boxSizing: 'border-box'
    },
    disabled: {
      opacity: theme.disabledOpacity,
      '&:hover, & $arrow': {
        cursor: 'default'
      }
    },
    hidden: {
      display: 'none'
    },
    visible: {
      display: 'block'
    },
    arrowContainer: {
      position: 'relative'
    },
    arrow: {
      position: 'absolute',
      top: 22,
      left: 6,
      zIndex: 2,
      transform: 'rotate(-90deg)',
      flex: '1 1 0',
      color: theme.table.arrowColor,
      '&.isOpen': {
        transform: 'rotate(0deg)'
      },
      '&.active': {
        color: theme.table.arrowActiveColor
      },
      '&:hover': {
        cursor: 'pointer'
      }
    },
    nestedChildrenContainer: {},
    paddingSizeSmall: {
      padding: '0 24px'
    },
    paddingSizeMedium: {
      padding: '0 48px'
    },
    dividerSmall: {
      margin: '0 24px'
    },
    dividerMedium: {
      margin: '0 48px'
    }
  };
};